module.exports = __webpack_public_path__ + "img/traditional-approach.68c839f6.png";